import type { AssistantMode } from '@/stores/use-ui-store';

/**
 * Decide the assistant mode when the active entity changes.
 *
 * The floating "Ask Nula" bar is available on every authenticated route, so it
 * surfaces (collapsed) even with no entity open — document context is just
 * absent there. An already-visible session (expanded/fullTab/sidebar/collapsed)
 * is left untouched so navigation doesn't clobber an in-progress interaction.
 */
export function resolveAssistantMode(
  _activeEntityId: string | null,
  currentMode: AssistantMode,
): AssistantMode {
  if (currentMode === 'hidden') return 'collapsed';
  return currentMode;
}
